import React, { FC, useMemo } from 'react';

import NotificationBanner from '~/components/atoms/NotificationBanner';
import {
  GB_FEATURE_KEYS,
  LiveUserNotificationPlaces,
} from '~/services/abTests/features';
import { growthBook } from '~/services/abTests/growthBook';

type Props = {
  place: LiveUserNotificationPlaces;
  children: React.ReactNode;
};

const LiveNotificationMiddleware: FC<Props> = ({ place, children }) => {
  const liveNotifications = useMemo(() => {
    return growthBook.getFeatureValue(GB_FEATURE_KEYS.LIVE_USER_NOTIFICATIONS);
  }, []);

  const pageNotification = useMemo(() => {
    return liveNotifications?.find((msg) => msg.place === place);
  }, [liveNotifications, place]);

  return (
    <>
      {pageNotification && (
        <NotificationBanner
          message={pageNotification.message}
          variant={pageNotification.variant}
        />
      )}
      {children}
    </>
  );
};

export default LiveNotificationMiddleware;
